import 'default-passive-events';
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n/index';
import './init/log.js';
import './init/glo-prototype';

// 全局指令
import './directives/index';
// 全局过滤器
import './filters/index';
import router from './routes';
import store from './store';

// 系统通用重置样式
import '@/assets/themes/default.less';
import '@/assets/css/index.less';
import { getLocationParameters, sessionOrLocal } from '@/tools/utils';

// 根据环境, 动态引入eruda
import('./init/vh-console.js');

Vue.config.productionTip = false;

const clientTokenVal = getLocationParameters('token');
if (clientTokenVal) {
  sessionOrLocal.set('token', clientTokenVal, 'localStorage');
  sessionOrLocal.set('tokenRefresh', new Date().getTime(), 'localStorage');
}

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
